module.exports = __webpack_public_path__ + "static/media/volar-gold.861aa9c0.png";